import React, { useId } from 'react';

export const STAR = {
    NOT_ATTEMPTED: {
        display: 'Not attempted',
        class: 'triangle-before',
        color: '#707070',
        ariaLabel: 'Grey star not attempted',
        starFill: 'EMPTY',
    },
    ATTEMPTED: {
        display: 'Attempted',
        class: 'circle-before',
        color: '#B260AE',
        ariaLabel: 'Purple star attempted',
        starFill: 'HALF',
    },
    ACHIEVED: {
        display: 'Achieved',
        class: 'square-before',
        color: '#288132',
        ariaLabel: 'Green star achieved',
        starFill: 'FULL',
    },
};

const starPoints = `
  50,72 75.75,87.5 69,58.2 91.7,38.5 61.7,36
  50,8.3 38.3,36 8.3,38.5 31,58.2 24.25,87.5
`;

const AchievementStar = ({
        altText = 'star',
        starFill = STAR.NOT_ATTEMPTED.starFill,
        starColor = STAR.NOT_ATTEMPTED.color,
        width = 24,
        height = 24,
        strokeColor = 'black',
        strokeWidth = 3,
        viewBox = '0 0 100 100',
        style = {},
        ariaHidden = false
    }) => {
    const id = useId(); // Unique per component instance
    const clipPathId = `half-clip-${id}`;
    const showHalf = starFill === STAR.ATTEMPTED.starFill;
    const showFull = starFill === STAR.ACHIEVED.starFill;

    return (
        <svg
            width={width}
            height={height}
            viewBox={viewBox}
            role="img"
            {...(altText ? { 'aria-label': altText } : {})}
            style={style}
            {...(ariaHidden ? { 'aria-hidden': true } : {})}
        >
            {/* Background outline */}
            <polygon
                points={starPoints}
                fill="transparent"
                stroke={starColor}
                strokeWidth={strokeWidth}
            />

            {/* Clip path for half-filled star */}
            {(showHalf || showFull) && (
                <defs>
                    <clipPath id={clipPathId}>
                        <rect x="0" y="0" width="50" height="100" />
                    </clipPath>
                </defs>
            )}

            {showHalf && (
                <polygon
                    points={starPoints}
                    fill={starColor}
                    clipPath={`url(#${clipPathId})`}
                />
            )}

            {showFull && (
                <polygon
                    points={starPoints}
                    fill={starColor}
                />
            )}
        </svg>
    );
};

export default AchievementStar;